import { useTranslation } from '@/hooks/useTranslation';
import { useToast } from '@/components/layout/Toast';
import {
  AdminCompaniesScreenDocument,
  AdminEnterprisesWithLicenseScreenDocument,
  AdminEnterprisesWithoutLicenseScreenDocument,
  useDeleteEnterpriseButtonMutation,
} from '@/graphql/generated';
import {
  ConfirmationModalType,
  useConfirmationModal,
} from '@/components/modals/ConfirmationModal';
import { Loader } from '@/components/generic/Loader';

export function DeleteEnterpriseButton({
  enterpriseId,
}: {
  enterpriseId: string;
}) {
  const { t } = useTranslation();
  const toast = useToast();
  const { openConfirmationModal } = useConfirmationModal();

  const [deleteMutation, { loading }] = useDeleteEnterpriseButtonMutation();

  const deleteEnterprise = () => {
    deleteMutation({
      variables: {
        input: {
          id: enterpriseId,
        },
      },
      refetchQueries: [
        AdminCompaniesScreenDocument,
        AdminEnterprisesWithLicenseScreenDocument,
        AdminEnterprisesWithoutLicenseScreenDocument,
      ],
    })
      .then(() => {
        toast.openToastWithMessage(t('admin:companies.toast.company_deleted'));
      })
      .catch((err) => {
        toast.openToastWithError(err.message);
      });
  };

  return (
    <button
      className="primary danger small"
      disabled={loading}
      onClick={() =>
        openConfirmationModal({
          titleBar: t('global:delete'),
          description: t('project.delete.content'),
          callbackIfConfirmed: deleteEnterprise,
          type: ConfirmationModalType.Danger,
        })
      }
    >
      {loading && <Loader />}
      <div>{t('global:delete')}</div>
    </button>
  );
}
